import { Popover } from 'antd';
import { useFela } from 'react-fela';

import { DropdownButton, Text } from '@/modules/ui';

import * as felaRules from './VaultMembersCell.rules';

export interface VaultMember {
    id?: string;
    name?: string;
    email?: string;
}

export interface VaultMembersCellProps {
    members?: VaultMember[];
}

const labelOf = ({ name, email }: VaultMember) => name || email;

export const VaultMembersCell = ({ members }: VaultMembersCellProps) => {
    const { css } = useFela();

    if (!members?.length) {
        return null;
    }

    if (members.length === 1) {
        return (
            <Text elementType='span' variant='ParagraphSmallMedium'>
                {labelOf(members[0])}
            </Text>
        );
    }

    return (
        <Popover
            arrow={false}
            placement='bottom'
            content={
                <div className={css(felaRules.members)}>
                    {members.map(member => (
                        <Text key={member.id} elementType='span' variant='ParagraphSmallMedium'>
                            {labelOf(member)}
                        </Text>
                    ))}
                </div>
            }
        >
            <DropdownButton>{members.length}</DropdownButton>
        </Popover>
    );
};
